module.exports = __webpack_public_path__ + "media/images/favicons/favicon-monday-24cd60da14fd34c351e6ed966114a68f.ico";